<template>
    <div>
        <div>
            <el-table ref="table" :data="tableData" border class="jxzb-tables">
                <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center"></el-table-column>
                <el-table-column prop="personName" label="操作人" width="130" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="operateTime" label="操作时间" width="150" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="updateType" label="变更类型" width="130" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="updateContent" label="变更内容" align="left" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            return moment(val).format('YYYY-MM-DD HH:mm')
        }
    },
    components: {},
    props: {
        row: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            tableData: []
        }
    },
    computed: {},
    watch: {},
    created() {
        // this.$bus.on('meetInfoSeventh', this.meetInfoSeventh)
        this.meetInfoSeventh()
    },
    beforeDestroy() {
        // this.$bus.off('meetInfoSeventh', this.meetInfoSeventh)
    },
    mounted() {},
    methods: {
        meetInfoSeventh() {
            this.getTableData()
        },
        async getTableData() {
            const data = [{ compare: '=', field: 'meetId', merge: true, value: this.row.id }]
            const res = await this.$app.querydata('/hygl/meetUpdateLog/querydata', data, 'operateTime desc')
            if (res.code === 'success') {
                this.tableData = res.body.listdata
            } else {
                this.$message({ message: res.message, type: 'warning' })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.dialog_top {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .el-button {
        margin-left: 10px;
        padding: 8px 15px;
    }
}
.contQR {
    width: 372px;
    height: 500px;
    margin: 0 auto;
    h3,
    h4 {
        margin: 0;
    }
    img {
        width: 340px;
        height: 340px;
        margin: 0 auto;
    }
    p {
        margin: 0;
        padding: 0 40px;
        line-height: 22px;
    }
}
</style>
